import { FrontendAuthenticatedUserProfile } from '@atlassian/cssxp-typescommon';
import { USER_PROFILE_REQUEST_SUCCEEDED, USER_PROFILE_REQUESTED } from './action-types';

export const requestUserProfile = () => ({
  type: USER_PROFILE_REQUESTED,
});

export const userProfileRequestSucceeded = (profile: FrontendAuthenticatedUserProfile) => ({
  type: USER_PROFILE_REQUEST_SUCCEEDED,
  payload: profile,
});
